<template>
	<div class="technology-mobile">
		<!--TECHNOLOGY  BANNER-->
		<div class="technology-banner">
			<div class="technology-banner-img">
				<img :src="bannerList[0]?.img || require('@/assets/technologyMb/banner.png')" alt=""></img>
			</div>
			<div class="carousel-information" @click="openInquiryForm">
				<img src="../../assets/home/xinxi.png" alt="">
			</div>
		</div>

		<!-- KOMO Technology -->
		<div class="technology-content">
			<div class="area-title-mobile">
				<p class="area-titleTop-mobile">{{ pageData[0]?.value[0]?.title }}</p>
				<p class="area-titleBottom-mobile">{{ pageData[0]?.value[0]?.subheading }}</p>
			</div>
			<div class="swiper-wrapper-box" >
				<swiper ref="techSwiper" :options="customSwiperOptions" class="technology-swiper" style="position: relative;">
					<swiper-slide class="slide" v-for="(item,index) in pageData[0]?.value[0]?.content" :key="index">
						<img :src="item?.img" alt="" />
						<div class="swiper-slide-text">
              {{ item.img_title }}
            </div>
					</swiper-slide>
					<!-- <swiper-slide class="slide">
						<img src="../../assets/home/technology-2.png" alt="" />
					</swiper-slide>
					<swiper-slide class="slide">
						<img src="../../assets/home/technology-3.png" alt="" />
					</swiper-slide>
					<swiper-slide class="slide">
						<img src="../../assets/home/technology-1.png" alt="" />
					</swiper-slide> -->
				</swiper>
				<!-- 向前向后按钮 -->
				<div class="technology-swiper-button-prev">
					<img src="../../assets/homeMb/left.png" class="swiper-button" @click="prev"></img>
				</div>
				<div class="technology-swiper-button-next">
					<img src="../../assets/homeMb/right.png" class="swiper-button" @click="next"></img>
				</div>
			</div>
		</div>

		<!-- R&D Strength -->
		<div class="section r-d-strength">
			<div class="title">
				<div class="title-top">{{ pageData[1]?.value[0]?.title }}</div>
				<div class="title-bottom">{{ pageData[1]?.value[0]?.subheading }}</div>
			</div>
			<div class="images">
				<img :src="pageData[1]?.value[0]?.img" style="width: 100%;height: 100%;"></img>
				<!-- <div class="cloumn">
					<img :src="pageData[1]?.value[0]?.img_cont[0]?.img" alt="">
				</div>
				<div class="cloumn">
					<img :src="pageData[1]?.value[0]?.img_cont[1]?.img" alt="">
					<img :src="pageData[1]?.value[0]?.img_cont[2]?.img" alt="">
				</div>
				<div class="cloumn">
					<img :src="pageData[1]?.value[0]?.img_cont[3]?.img" alt="">
					<img :src="pageData[1]?.value[0]?.img_cont[4]?.img" alt="">
				</div>
				<div class="cloumn">
					<img :src="pageData[1]?.value[0]?.img_cont[5]?.img" alt="">
					<img :src="pageData[1]?.value[0]?.img_cont[6]?.img" alt="">
				</div>
				<div class="cloumn">
					<img :src="pageData[1]?.value[0]?.img_cont[7]?.img" alt="">
				</div> -->
			</div>
			<div class="main-title">
				{{ pageData[1]?.value[0]?.content_title }}
			</div>
			<div class="content" v-html="pageData[1]?.value[0]?.content_content">
				
			</div>
		</div>

		<!-- Factory Introduction -->
		<div class="section factory-introduction">
			<div class="title">{{ pageData[2]?.value[0]?.title }}</div>
			<div class="image">
				<img :src="pageData[2]?.value[0]?.img" alt="" />
			</div>
			<div class="main-title">
				<!-- KOMO Biological Research and Development Center -->
				 {{ pageData[2]?.value[0]?.subheading }}
			</div>
			<div class="content" v-html="pageData[2]?.value[0]?.content">
			</div>
			<!-- <div class="content">
				 {{ $t('technology.RD.bottomText2') }}
			</div> -->
		</div>


		<!-- Quality Raw Materials -->
		<div class="section quality-raw-materials">
			<div class="title">{{ pageData[3]?.value[0]?.title }}</div>
			<div class="quality-raw-materials-cont">
				<swiper ref="resolveSwiper" :options="swiperOptionsResolve" class="quality-raw-materials-swiper">
					<!-- <swiper-slide class="swiper-slide" v-for="item in resolveSlides" :key="item.id">
						<div class="technology-qual-cont-item-img">
							<img :src="item.url" alt="">
						</div>
						<div class="technology-qual-cont-item-text">
							<div class="technology-qual-cont-item-text-bg"></div>
							<div class="technology-qual-cont-item-text-font">{{ item.font }}</div>
						</div>
					</swiper-slide> -->
					<swiper-slide class="swiper-slide" v-for="(item,index) in pageData[3]?.value[0]?.content" :key="index">
						<div class="technology-qual-cont-item-img">
							<img :src="item.img" alt="">
						</div>
						<div class="technology-qual-cont-item-text">
							<div class="technology-qual-cont-item-text-bg"></div>
							<div class="technology-qual-cont-item-text-font">{{ item.title }}</div>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>


		<!-- International Patent and Award Exhibition -->
		<div class="section international-patent-and-award-exhibition">
			<!-- <div class="title">{{ pageData[4]?.value[0]?.title }}</div> -->
			 <div class="title">{{ $t('technology.inter.title') }}</div>
			<img class="image" src="@/assets/technologyMb/section6.png" alt="" />
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { bus } from '@/utils/bus';
import { getDataList,getBannerListingMobile } from '@/api/komo.js';
export default {
	name: 'TechnologyMobile',
	components: {
		Swiper,
		SwiperSlide
	},
	data() {
		return {
			customSwiperOptions: {
				effect: 'coverflow',
				loop: true,
				loopAdditionalSlides: 1,
				// slideToClickedSlide: true,
				coverflowEffect: {
					rotate: 0, // Y轴旋转角度
					stretch: -20, // 每个slide之间的拉伸值
					depth: 0, // slide的位置深度
					modifier: 1, // 效果倍率
					slideShadows: false // 禁用滑动阴影
				},
				centeredSlides: false, // 居中显示当前slide
				slidesPerView: 1,
				autoplay: false,
				// 关闭默认导航按钮
				navigation: false
			},
			resolveSlides: [
				{
					url: require('@/assets/technology/qual-1.png'),
					font: this.$t('technology.quality.font1')
				},
				{
					url: require('@/assets/technology/qual-2.png'),

					font: this.$t('technology.quality.font2')
				},
				{
					url: require('@/assets/technology/qual-3.png'),
					font: this.$t('technology.quality.font3')
				},
				{
					url: require('@/assets/technology/qual-4.png'),
					font: this.$t('technology.quality.font4')
				},
			],
			swiperOptionsResolve: {
				pagination: {
					el: '.swiper-pagination', // 分页器的选择器，与上面的类名相对应
					clickable: true, // 允许点击分页器切换幻灯片
				},
				// autoplay: {
				//     delay: 5000, // 自动切换时间间隔
				//     disableOnInteraction: true // 用户操作后是否停止自动切换，默认为true
				// },
				centeredSlides: true,
				loop: true, // 无限循环
				loopAdditionalSlides: 1, // 循环时额外复制的slide数量
				slideToClickedSlide: true, // 点击slide直接切换
				slidesPerView: 1.5, // 一次显示3个 slides
				spaceBetween: 20, // 设置 slides 之间的间距
			},
			currentImageIndex: 0,
			images: [
				require('@/assets/technologyMb/section2-show.png'),
				require('@/assets/technologyMb/section5-1.png'),
				require('@/assets/technologyMb/section5-2.png'),
				require('@/assets/technologyMb/section5-3.png')
			],
			bannerList: [],
			pageData: []
		}
	},
	computed: {
		swiper() {
			return this.$refs.techSwiper.$swiper
		}
	},
	mounted() {
		// this.getBannerData()
		// this.getDataList()
	},
	created() {
		this.initData()
	},
		
	methods: {
		// 初始化数据
		async initData(){
			const res = await getBannerListingMobile('4')
			if (res.error == 0) {
				this.bannerList = res?.data?.list || [];
			}
			const res1 = await getDataList(localStorage?.getItem('pageId'))
			this.pageData = res1?.data?.list || []
		},
		openInquiryForm(){
             bus.$emit('inquiry-form', true)
        },
		prev() {
			this.swiper.slidePrev()
		},
		next() {
			this.swiper.slideNext()
		},
		prevImage() {
			if (this.currentImageIndex > 0) {
				this.currentImageIndex--;
			} else {
				this.currentImageIndex = this.images.length - 1;
			}
		},
		nextImage() {
			if (this.currentImageIndex < this.images.length - 1) {
				this.currentImageIndex++;
			} else {
				this.currentImageIndex = 0;
			}
		}
	}
}
</script>

<style scoped>
.technology-mobile {
	position: relative;
	padding-bottom: 62vw;
	overflow-x: hidden;
	background: #F8F9FC;
}

/* banner */
.technology-banner {
	width: 100%;
	position: relative;
}

.technology-banner .technology-banner-img {
	width: 100%;
}

.technology-banner-img img {
	width: 100%;
	height: 100%;
}

.technology-banner .carousel-information {
	position: fixed;
    bottom: 3%;
    right: 3%;
    width: 25vw;
    height: 25vw;
    cursor: pointer;
    z-index: 999;
}

.technology-banner .carousel-information img {
	width: 100%;
	height: 100%;
}

/* KOMO Technology */
.technology-content {
	width: 100%;
	padding-bottom: 10%;
	/* background: #F8F9FC; */
}

.technology-content .swiper-wrapper-box {
	width: 100%;
	position: relative;
}


.technology-swiper {
	width: 75%;
	height: 300px;
}

.technology-swiper .slide img {
	width: 100%;
	height: 100%;
	position: relative;
}
.swiper-slide-text{
  position: absolute;
  top: 5%;
  right:5%;
  font-size: 3.5vw;
  color: #fff;
  font-weight: bold;
}

.technology-swiper-button-prev {
	position: absolute;
	top: 50%;
	left: 10px;
	transform: translateY(-50%);
}

.technology-swiper-button-next {
	position: absolute;
	top: 50%;
	right: 10px;
	transform: translateY(-50%);
}

.swiper-button {
	cursor: pointer;
	width: 8vw;
	height: 8vw;
}

/* 第二部分 */
.r-d-strength {
	width: 100%;
	/* background: #d5dcc880; */
	padding: 10% 0 0 0;
	background: #F8F9FC;
}

.r-d-strength .title {
	width: 100%;
	color: #1E1E1E;
	text-align: center;
	
}

.r-d-strength .title .title-top {
	font-size: 5.33vw;
	font-weight: bold;
}

.r-d-strength .title .title-bottom {
	font-size: 3.73vw;
	margin-top: 3.2vw;
	margin-bottom: 8vw;
}

.r-d-strength .images {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	flex-wrap: nowrap;
	gap: 1.87vw;
	padding: 10.67vw 3.2vw;
	padding-bottom: 5.33vw;
	background: #d5dcc880;
}

.r-d-strength .images .cloumn {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	flex-wrap: nowrap;
	overflow-x: auto;
	gap: 1.73vw;
}

.r-d-strength .images .cloumn img {
	width: 100%;
}

.r-d-strength .main-title {
	width: 100%;
	font-size: 4.13vw;
	font-weight: bold;
	color: #64715D;
	text-align: center;
	padding-bottom: 3.73vw;
	background: #d5dcc880;
}

.r-d-strength .content {
	width: 100%;
	color: #959595;
	font-size: 3.73vw;
	background: #d5dcc880;
	padding: 0 3.2vw 5vw 3.2vw;
}

/* 第三部分 */
.factory-introduction {
	width: 100%;
	background: #FFF;
	padding: 10.67vw 3.2vw;
}

.factory-introduction .title {
	width: 100%;
	color: #64715D;
	font-size: 4.53vw;
	font-weight: bold;
	text-align: center;
	margin-bottom: 5.33vw;
}

.factory-introduction .image {
	width: 100%;
	margin-bottom: 5.33vw;
}

.factory-introduction .image img {
	width: 100%;
}

.factory-introduction .main-title {
	width: 100%;
	font-size: 3.73vw;
	font-weight: bold;
	color: #1E1E1E;
}

.factory-introduction .content {
	width: 100%;
	color: #959595;
	font-size: 3vw;
}


/* 第四部分 */
.quality-raw-materials {
	width: 100%;
	background: #F8F9FC;
	padding: 10.67vw 0;
}

.quality-raw-materials .title {
	width: 100%;
	color: #64715D;
	font-size: 4.53vw;
	font-weight: bold;
	text-align: center;
	margin-bottom: 5.33vw;
}

.quality-raw-materials-cont {
	width: 100%;
}

.quality-raw-materials-swiper {
	width: 100%;
}

.quality-raw-materials-cont .swiper-slide {
	width: 100%;
	position: relative;
}

.quality-raw-materials-cont .swiper-slide img {
	width: 100%;
	height: 100%;
}

.technology-qual-cont-item-img{
  width: 100%;
  height: 30%;
}
.technology-qual-cont-item-img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}
.technology-qual-cont-item-text{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 18%;
}
.technology-qual-cont-item-text-bg{
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  background: #1E1E1E;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 0px 0px 30px 30px;
  opacity: 0.6;
}
.technology-qual-cont-item-text-font{
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}


/* 第五部分 */
.international-patent-and-award-exhibition {
	width: 93.6vw;
	background: #FFF;
	padding-top: 8vw;
	padding-bottom: 4.53vw;
	position: absolute;
	bottom: -5vw;
	left: 3.2vw;
	border-radius: 2.67vw;
}

.international-patent-and-award-exhibition .title {
	width: 100%;
	color: #64715D;
	font-size: 4.53vw;
	font-weight: bold;
	text-align: center;
	margin-bottom: 5.33vw;
}

.international-patent-and-award-exhibition .image {
	width: 100%;
}
</style>
